import styled from 'styled-components'

const LinkHelpPageUi = styled.div`
  display: flex;
  align-items: center;
  padding-left: 6px;
  margin: 10px 0 5px 0;
  border-left: solid 3px var(--color-blue);
`

export default LinkHelpPageUi
